module.exports = __webpack_public_path__ + "img/csr_110923_A.c45cd7d8.jpg";